import { type FC } from "react";
import * as styles from "./styles.css";

/**
 * 違反報告における書類提出の説明コンポーネント
 */
export const DocumentDescription: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <p className={styles.heading}>A：採用されていることを客観的に示す資料（下記のうち1種類）</p>
        <ul className={styles.ul}>
          <li className={styles.li}>給与明細</li>
          <li className={styles.li}>雇用保険被保険者資格取得等確認通知書(被保険者通知用)</li>
          <li className={styles.li}>雇用保険被保険者資格喪失確認通知書(被保険者通知用)</li>
          <li className={styles.li}>源泉徴収票</li>
          <li className={styles.li}>離職票1の控え</li>
          <li className={styles.li}>離職用2の控え</li>
          <li className={styles.li}>雇用保険受給資格者証</li>
        </ul>
      </div>
      <div className={styles.section}>
        <p className={styles.heading}>
          B：採用されていることを客観的に示す資料（下記のうち2種類以上）
        </p>
        <ul className={styles.ul}>
          <li className={styles.li}>雇用契約書、労働条件通知書</li>
          <li className={styles.li}>通帳やネットバンクの入出金明細</li>
          <li className={styles.li}>シフト表</li>
          <li className={styles.li}>就業中の写真・制服姿</li>
          <li className={styles.li}>顧客からもらった書類</li>
          <li className={styles.li}>顧客担当者とのSMS・メール・LINE等のやり取り</li>
        </ul>
      </div>
      <div className={styles.section}>
        <p className={styles.heading}>
          C:違反行為(採用の口止めや虚偽報告)を求められたことを客観的に示す資料
        </p>
        <ul className={styles.ul}>
          <li className={styles.li}>顧客担当者とのSMS・メール・LINE等のやり取り</li>
        </ul>
      </div>
      <div className={styles.noticeBox}>
        <h3 className={styles.heading}>注意事項</h3>
        <ul className={styles.ul}>
          <li className={styles.li}>
            必要情報(氏名、企業名、資格取得年月日、離職年月日など)が記載された資料を提出ください。
          </li>
          <li className={styles.li}>
            ご自身以外の個人情報や機微情報が含まれる場合は、黒塗り等のマスキングをお願いします。
          </li>
          <li className={styles.li}>
            違反行為の追求には長い時間がかかるため、支給対象となったかどうかの回答はいたしません。対象となった場合のみ、ご記載いただいたメールアドレスへ、メールにてご連絡いたします。
          </li>
        </ul>
      </div>
    </div>
  );
};
